__turbopack_context__.v({
  "imageRoot": "ArticleModuleHeroSidebar-module-scss-module__h4Udxq__imageRoot",
  "meta": "ArticleModuleHeroSidebar-module-scss-module__h4Udxq__meta",
  "wrapper": "ArticleModuleHeroSidebar-module-scss-module__h4Udxq__wrapper",
});
